import { DEFAULT_PERMISSIONS } from '@/constants/constants';
import { PlantComparisonReport, StationsDropDown } from '@/Interface/analysisModule';
import { MonthlyReport } from '@/Interface/monthlyReport';
import { RegionAndCity } from '@/Interface/regionAndCity';
import { TariffTypeAndCompany } from '@/Interface/tariffs';
import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PermissionsService } from '@services/permissions.service';
import { UtilityService } from '@services/utility.service';
import * as Highcharts from 'highcharts';
import moment from 'moment';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-plant-comparison',
  templateUrl: './plant-comparison.component.html',
  styleUrls: ['./plant-comparison.component.scss']
})
export class PlantComparisonComponent implements OnInit {
  public pageSizeControl = new FormControl(10);
  pageSize: number;
  pageToGo: number = 1;
  searchElement = '';
  serialNumberArray: Array<number> = [];
  next_page: number;
  current_page: number;
  previous_page: number;
  total_pages: number;
  total_items: number;
  private latestQueryParams: any = {};
  sortColumn: string = null;
  sortOrder: 'asc' | 'desc' = null;
  searchSubject: Subject<string> = new Subject();
  loader: boolean = false
  isLoadingTableInner: boolean = false

  public pageRecordOptions = [
    { value: '10', label: '10' },
    { value: '25', label: '25' },
    { value: '50', label: '50' },
    { value: '100', label: '100' },
    { value: '200', label: '200' },
  ];
  selectedPlant1: StationsDropDown | null = null;
  selectedPlant2: StationsDropDown | null = null;
  filteredPlantList1: StationsDropDown[] = [];
  filteredPlantList2: StationsDropDown[] = [];
  public selectedId: number
  allPlantList: StationsDropDown[];
  selectedDate: Date = new Date();
  datePickerConfig: Partial<BsDaterangepickerConfig> = {
    showWeekNumbers: false,
    dateInputFormat: 'DD/MM/YYYY',
  };
  plantDetails: MonthlyReport | null = null;
  modalRef: NgbModalRef | null = null;
  isDownloading: boolean;
  downtimeList: { label: string, value: string }[] = [];
  form = {
    tax: '',
    lossOfEnergy: '',
    remarks: ''
  };
  reportForm: FormGroup;
  selectedPlantA: string = '';
  selectedPlantB: string = '';

  statusOptions = ['Done', 'Pending', 'N/A', 'In Progress'];
  comparisonList: PlantComparisonReport = null
  permissions = { ...DEFAULT_PERMISSIONS };
  permissionsReady: boolean = false;
  constructor(private modalService: NgbModal,
    private _utilityService: UtilityService,
    private toaster: ToastrService,
    private datePipe: DatePipe,
    private fb: FormBuilder,
    private permService: PermissionsService,
  ) { }

  ngOnInit(): void {
    this.initComponent()
  }
  async initComponent() {
    this.loader = true
    this.reportForm = this.createForm();
    await this.getComponentPermissions();

    if (this.permissions.canView) {
      this.getPlantsDropDown();
      this.generateDowntimeOptions();
    }
    setTimeout(() => {
      this.loader = false;
    }, 250);
  }

  async getComponentPermissions() {
    const url = this.permService.getCurrentUrl();
    // const menuFromLocal = this.permService.loadMenuFromLocalStorage();
    const menuFromLocal = await this.permService.waitForMenuInLocalStorage();

    const matchedMenu = this.permService.findMenuPermissions(menuFromLocal, url);

    this.permissions = matchedMenu
      ? {
        canAdd: !!matchedMenu.canAdd,
        canEdit: !!matchedMenu.canEdit,
        canView: !!matchedMenu.canView,
        canDelete: !!matchedMenu.canDelete
      }
      : { ...DEFAULT_PERMISSIONS };

    this.permissionsReady = true;
  }
  get hasAnyActionPermission(): boolean {
    return (
      this.permissionsReady &&
      (this.permissions.canView ||
        this.permissions.canEdit ||
        this.permissions.canDelete)
    );
  }
  createForm(): FormGroup {
    // const today = new Date().toISOString().split('T')[0];

    return this.fb.group({
      // date: [today, Validators.required],
      plantA: [null, Validators.required],
      plantB: [null, Validators.required],

      // Plant A Fields - all optional
      pv_modules_plant_a: [''],
      cleaning_status_plant_a: [''],
      corrective_maintenance_plant_a: [''],
      spare_parts_replacement_plant_a: [''],
      unplanned_downtime_plant_a: ['', [
        Validators.pattern(/^\d+(\.\d{1,2})?$/),
        Validators.min(0)
      ]],
      lost_generation_plant_a: ['', [
        Validators.pattern(/^\d+(\.\d{1,2})?$/),
        Validators.min(0)
      ]],
      communication_issue_plant_a: [''],
      grid_issue_plant_a: [''],
      other_issue_plant_a: [''],

      // Plant B Fields - all optional
      pv_modules_plant_b: [''],
      cleaning_status_plant_b: [''],
      corrective_maintenance_plant_b: [''],
      spare_parts_replacement_plant_b: [''],
      unplanned_downtime_plant_b: ['', [
        Validators.pattern(/^\d+(\.\d{1,2})?$/),
        Validators.min(0)
      ]],
      lost_generation_plant_b: ['', [
        Validators.pattern(/^\d+(\.\d{1,2})?$/),
        Validators.min(0)
      ]],
      communication_issue_plant_b: [''],
      grid_issue_plant_b: [''],
      other_issue_plant_b: [''],

      // Recommendations - optional
      recommendations: ['']
    });
  }

  private generateDowntimeOptions() {
    for (let h = 0; h < 24; h++) {
      for (let m = 0; m < 60; m += 5) { // increment by 5 minutes for better usability
        const hours = h.toString().padStart(2, '0');
        const minutes = m.toString().padStart(2, '0');
        this.downtimeList.push({
          label: `${hours}h ${minutes}m`,
          value: `${hours}:${minutes}`
        });
      }
    }
  }
  // billingChartInit(): void {
  //   const items = this.plantDetails?.billing_period?.items || [];

  //   const categories = items.map(item => {
  //     const dateObj = new Date(item.date);
  //     const day = dateObj.getDate();
  //     const monthShort = dateObj.toLocaleString('default', { month: 'short' });
  //     return `${day}-${monthShort}`; // e.g., 14-Aug
  //   });

  //   const data = items.map(item => item.pvyield);

  //   // ✅ Check if all data is 0 or null/undefined
  //   const allDataEmpty = data.length === 0 || data.every(val => !val || val === 0);

  //   if (categories.length === 0 || allDataEmpty) {
  //     this.billingChart = null;
  //     return;
  //   }
  //   // ✅ If data is valid, build chart
  //   this.billingChart = {
  //     chart: {
  //       type: 'column',
  //       backgroundColor: 'transparent',
  //       height: 467,
  //     },
  //     title: {
  //       text: ''
  //     },
  //     credits: {
  //       enabled: false
  //     },
  //     xAxis: {
  //       categories: categories,
  //       crosshair: true,
  //       labels: {
  //         rotation: 0,
  //         autoRotation: undefined,
  //         style: {
  //           color: '#000',
  //           fontSize: '12px',
  //           fontWeight: '400'
  //         }
  //       }
  //     },
  //     yAxis: {
  //       title: {
  //         text: null
  //       },
  //       labels: {
  //         style: {
  //           color: '#000',
  //           fontSize: '12px',
  //           fontWeight: '400'
  //         }
  //       }
  //     },
  //     tooltip: {
  //       valueSuffix: ' kWh'
  //     },
  //     legend: {
  //       enabled: false
  //     },
  //     plotOptions: {
  //       column: {
  //         borderRadius: 2,
  //         pointWidth: 36,
  //         color: '#FB8C04'
  //       }
  //     },
  //     series: [
  //       {
  //         name: 'PV Yield',
  //         type: 'column',
  //         data: data
  //       }
  //     ]
  //   };
  // }

  // roiChartInit(): void {
  //   if (!this.plantDetails?.roi?.graph) {
  //     this.roiChart = null;
  //     return;
  //   }

  //   const graph = this.plantDetails.roi.graph;

  //   this.roiChart = {
  //     chart: {
  //       type: 'column',
  //       backgroundColor: 'transparent',
  //       height: 284,
  //     },
  //     title: {
  //       text: ''
  //     },
  //     credits: {
  //       enabled: false
  //     },
  //     xAxis: {
  //       categories: [''], // Dummy, not shown
  //       crosshair: true,
  //       title: {
  //         text: null
  //       },
  //       labels: {
  //         enabled: false // Hide X-axis labels
  //       }
  //     },
  //     yAxis: {
  //       min: 0,
  //       title: {
  //         text: null
  //       },
  //       labels: {
  //         style: {
  //           color: '#000',
  //           fontSize: '12px',
  //           fontWeight: '400'
  //         }
  //       }
  //     },
  //     tooltip: {
  //       valueDecimals: 2,
  //       valueSuffix: ' kWh',
  //       shared: true
  //     },
  //     legend: {
  //       enabled: true,
  //       itemStyle: {
  //         color: '#000',
  //         fontSize: '12px',
  //         fontWeight: '400'
  //       }
  //     },
  //     plotOptions: {
  //       column: {
  //         borderRadius: 2,
  //         pointWidth: 36,
  //         grouping: true,
  //         pointPadding: 0.2,
  //       }
  //     },
  //     series: [
  //       {
  //         name: 'Total Savings',
  //         type: 'column',
  //         data: [graph.TotalSavings_LifetimeEnergy],
  //         color: '#F9C62D'
  //       },
  //       {
  //         name: 'Investment Recovery',
  //         type: 'column',
  //         data: [graph.InvestmentRecovery_InstallationCost],
  //         color: '#EF4323'
  //       },
  //       {
  //         name: 'Savings Beyond Investment',
  //         type: 'column',
  //         data: [graph.SavingsBeyondInvestment],
  //         color: '#0A9160'
  //       }
  //     ]
  //   };
  // }

  openEditPopUp(item: RegionAndCity, contentupdate: any) {
    this.selectedId = item.id;
    this.modalService.open(contentupdate);
  }

  openDownloadPopup(content: any) {
    const stationCode = this.latestQueryParams['stationCode'] || null;
    const date = this.latestQueryParams['date'] || null;
    if (stationCode && date) {
      this.modalRef = this.modalService.open(content, { centered: true });
    } else {
      this.toaster.warning(
        'Please select both Station Code and Date before downloading.');
    }
  }


  private updateQueryParams(paramsToUpdate: any): void {
    this.latestQueryParams = {
      ...this.latestQueryParams,
      ...paramsToUpdate
    };

    if (this.latestQueryParams.search === '') {
      this.latestQueryParams.search = null;
    }
    if (this.latestQueryParams.page === 1) {
      this.latestQueryParams.page = null;
    }

    if (this.latestQueryParams.size === 10) {
      this.latestQueryParams.size = null;
    }
    if (this.latestQueryParams.size === 10) {
      this.latestQueryParams.size = null;
    }
    if (this.latestQueryParams.sort === null) {
      delete this.latestQueryParams.sort;
    }

    if (this.latestQueryParams.column === null) {
      delete this.latestQueryParams.column;
    }
    if (this.latestQueryParams.stationCode === null) {
      delete this.latestQueryParams.stationCode;
    }
    if (this.latestQueryParams.date === null) {
      delete this.latestQueryParams.date;
    }

    if (this.latestQueryParams.page === 1 || (this.latestQueryParams.page && (this.latestQueryParams.search))) {
      if (this.latestQueryParams.page > 1) {
        this.latestQueryParams.page = paramsToUpdate.page;
        if (this.latestQueryParams.size > 10) {
          this.latestQueryParams.size = paramsToUpdate.size;
        }
      } else {
        this.latestQueryParams.page = null;
      }
    }
    if (!this.next_page && (paramsToUpdate.size || paramsToUpdate.search)) {
      // Only include size or search in the query params
      this.latestQueryParams = {
        size: paramsToUpdate.size || null,
        search: paramsToUpdate.search || null
      };
    }
    this.getTableData();
  }
  closeModal() {
    if (this.modalRef) {
      this.modalRef.close('Closed');
    }
  }


  // private getTableData(): void {
  //   const stationCode = this.latestQueryParams['stationCode'] || null;
  //   const date = this.latestQueryParams['date'] || null;
  //   if (stationCode && date) {
  //     this.getPlantComparisonReport(stationCode, date);
  //   }
  //   else {
  //     this.plantDetails = null;
  //   }
  // }
  public getTableData(): void {
    const stationCode = this.latestQueryParams['stationCode'] || null;
    const date = this.latestQueryParams['date'] || null;

    const tax = parseFloat(this.form.tax);
    const loss = parseFloat(this.form.lossOfEnergy);
    const remarks = this.form.remarks;

    const isFormValid = !isNaN(tax) && !isNaN(loss);

    if (isFormValid) {
      if (stationCode && date) {
        this.getPlantComparisonReport(stationCode, date, tax, loss, remarks);
      }
      else {
        this.plantDetails = null;
        this.toaster.error('Missing required form fields or filters');
      }
    }
    // if (stationCode && date && isFormValid) {
    //   this.getPlantComparisonReport(stationCode, date, tax, loss, remarks);
    // } else {
    //   this.plantDetails = null;
    //   // Optionally show error
    //   this.toaster.error('Missing required form fields or filters');
    // }
  }
  private getYearMonthFromDate(date: string | null): { year: number | null, month: number | null } {
    if (!date) {
      return { year: null, month: null };
    }

    const parsedDate = new Date(date);

    if (isNaN(parsedDate.getTime())) {
      return { year: null, month: null };
    }

    return {
      year: parsedDate.getFullYear(),
      month: parsedDate.getMonth() + 1 // Month is 0-based
    };
  }

  getPlantComparisonReport(stationCode: string | null, date: string | null, tax: number | null, loss: number | null, remarks: string | null): void {
    this.isLoadingTableInner = true;
    this.plantDetails = null;
    const { year, month } = this.getYearMonthFromDate(date);

    const payload = {
      station_code: stationCode,
      date: date,
      tax_rate: tax,
      loss_kwh: loss,
      remarks: remarks,
      year: year,
      month: month
    };
    console.log('payload:', payload)
    this._utilityService.getPlantComparisonReport(payload).subscribe({
      next: (res: MonthlyReport) => {
        this.plantDetails = res;
        this.isLoadingTableInner = false; // Stop loader after success
        // this.billingChartInit(); // ← Add this line
        // this.roiChartInit()
      },
      error: (err: any) => {
        console.error('Error fetching daily report:', err);
        this.isLoadingTableInner = false; // Stop loader on error too
        // Optional: Show a toast/snackbar or set a message for UI
      }
    });
  }

  public searchData(event: Event): void {
    this.searchElement = (event.target as HTMLInputElement)?.value || '';
    this.searchSubject.next(this.searchElement);
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.total_pages) {
      this.updateQueryParams({ page: page });
    }
  }

  navigatePage(direction: string): void {
    if (direction === 'prev' && this.current_page > 1) {
      this.goToPage(this.current_page - 1);
    } else if (direction === 'next' && this.next_page !== null) {
      this.goToPage(this.current_page + 1);
    }
  }

  // Add a method to navigate to the entered page
  navigateToPage(): void {
    if (this.pageToGo >= 1 && this.pageToGo <= this.total_pages) {
      this.goToPage(this.pageToGo);
    }
  }

  public changePageSize(): void {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.pageSize = this.pageSizeControl.value!;
    this.updateQueryParams({ size: this.pageSize })
  }

  enablePagination() {
    const linkElement = document.getElementById('prevPage');

    if (this.previous_page === null) {
      linkElement.setAttribute('disabled', 'true');
      linkElement.style.pointerEvents = 'none';
      linkElement.style.color = 'gray';
      linkElement.addEventListener('click', (event) => {
        event.preventDefault();
      });
    } else {
      linkElement.removeAttribute('disabled');
      linkElement.style.pointerEvents = 'auto';
      linkElement.style.color = '';
      linkElement.removeEventListener('click', (event) => {
        event.preventDefault();
      });
    }
  }
  deleteCity(id: number) {
    if (id) {
      this._utilityService.deleteRegionAndCity(id).pipe(
        catchError(error => {
          if (error.status === 400) {
            this.toaster.error(error.error.message || 'Bad request');
          } else {
            this.toaster.error('An error occurred. Please try again later.');
          }
          this.resetForm();
          return throwError(() => error);
        })
      ).subscribe(() => {
        // Success path — runs on 200, 204, etc.
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'City deleted successfully',
          showConfirmButton: false,
          timer: 1000
        });
        this.getTableData();
      });
    }
  }
  deleteTariffType(id: number, content: any) {
    this.modalService.open(content, { centered: true }).result.then(
      (result) => {
        if (result === 'confirm') {
          this.deleteCity(id)
        }
      },
      (reason) => {
        console.log('Modal dismissed:', reason);
      }
    );
  }
  public selectPlants(plants: any): void {
    this.updateFilteredPlantLists();
  }
  getPlantsDropDown() {
    this._utilityService.getStationsDropDown().subscribe((res) => {
      if (res) {
        this.allPlantList = res.data;
        this.updateFilteredPlantLists();
      }
    });
  }
  onRangeChange(date: Date): void {
    if (date) {
      this.selectedDate = date; // Store the selected month only
      const formattedFromDate = moment(date).format('YYYY-MM-DD');
      this.updateQueryParams({ date: formattedFromDate, });
    } else {
      this.updateQueryParams({ date: null, });
    }
  }

  clearDateRange(): void {
    if (this.selectedDate) {
      this.selectedDate = null
      this.updateQueryParams({ date: null })
    }
  }
  // Add this new method to filter plant lists
  updateFilteredPlantLists(): void {
    if (!this.allPlantList) {
      this.filteredPlantList1 = [];
      this.filteredPlantList2 = [];
      return;
    }

    // Filter Plant 1 list: exclude Plant 2's selection
    this.filteredPlantList1 = this.selectedPlant2
      ? this.allPlantList.filter(plant => plant.stationCode !== this.selectedPlant2.stationCode)
      : [...this.allPlantList];

    // Filter Plant 2 list: exclude Plant 1's selection
    this.filteredPlantList2 = this.selectedPlant1
      ? this.allPlantList.filter(plant => plant.stationCode !== this.selectedPlant1.stationCode)
      : [...this.allPlantList];
  }

  selectPlantA(event: StationsDropDown | null): void {
    if (!event) {
      this.selectedPlantA = '';
      this.reportForm.patchValue({ plantA: '' });
      this.filteredPlantList2 = [...this.allPlantList];
      return;
    }

    this.selectedPlantA = event.stationCode;
    this.reportForm.patchValue({ plantA: this.selectedPlantA });

    // Filter out selected plant from Plant B list
    this.filteredPlantList2 = this.allPlantList.filter(
      plant => plant.stationCode !== this.selectedPlantA
    );
  }

  // Update selectPlantB method (around line 473)
  selectPlantB(event: StationsDropDown | null): void {
    if (!event) {
      this.selectedPlantB = '';
      this.reportForm.patchValue({ plantB: '' });
      this.filteredPlantList1 = [...this.allPlantList];
      return;
    }

    this.selectedPlantB = event.stationCode;
    this.reportForm.patchValue({ plantB: this.selectedPlantB });

    // Filter out selected plant from Plant A list
    this.filteredPlantList1 = this.allPlantList.filter(
      plant => plant.stationCode !== this.selectedPlantB
    );
  }

  onSubmit(): void {
    if (this.reportForm.valid) {
      const formData = this.prepareFormData();
      console.log('Form Data:', formData);
      // Call your API service here
      this.generateReport(formData);

    } else {
      this.markFormGroupTouched(this.reportForm);
    }
  }
  prepareFormData(): any {
    const formValue = this.reportForm.value;

    return {
      date: this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd'),
      station_codes: [formValue.plantA, formValue.plantB],
      user_input: {
        pv_modules_plant_a: formValue.pv_modules_plant_a,
        pv_modules_plant_b: formValue.pv_modules_plant_b,
        cleaning_status_plant_a: formValue.cleaning_status_plant_a,
        cleaning_status_plant_b: formValue.cleaning_status_plant_b,
        corrective_maintenance_plant_a: formValue.corrective_maintenance_plant_a,
        corrective_maintenance_plant_b: formValue.corrective_maintenance_plant_b,
        spare_parts_replacement_plant_a: formValue.spare_parts_replacement_plant_a,
        spare_parts_replacement_plant_b: formValue.spare_parts_replacement_plant_b,
        unplanned_downtime_plant_a: this.toNumberOrNull(formValue.unplanned_downtime_plant_a),
        unplanned_downtime_plant_b: this.toNumberOrNull(formValue.unplanned_downtime_plant_b),
        lost_generation_plant_a: this.toNumberOrNull(formValue.lost_generation_plant_a),
        lost_generation_plant_b: this.toNumberOrNull(formValue.lost_generation_plant_b),
        communication_issue_plant_a: formValue.communication_issue_plant_a,
        communication_issue_plant_b: formValue.communication_issue_plant_b,
        grid_issue_plant_a: formValue.grid_issue_plant_a,
        grid_issue_plant_b: formValue.grid_issue_plant_b,
        other_issue_plant_a: formValue.other_issue_plant_a,
        other_issue_plant_b: formValue.other_issue_plant_b,
        recommendations: formValue.recommendations
      }
    };
  }
  private toNumberOrNull(value: any): number | null {
    const num = parseFloat(value);
    return isNaN(num) ? null : num;
  }

  generateReport(data: any): void {
    // Implement your report generation logic
    // console.log('Generating report with:', data);
    this.loader = true
    this._utilityService.getPlantComparisonReport(data).subscribe({
      next: (res: any) => {
        this.loader = false
        this.comparisonList = res.data;
        this.isLoadingTableInner = false;
      },
      error: (err: any) => {
        this.loader = false
        console.error('Error fetching plant comparison report:', err);
        this.isLoadingTableInner = false;
      }
    });

  }
  downloadReport(): void {
    if (this.reportForm.valid) {
      const formData = this.prepareFormData();
      formData.report = true
      this.isDownloading = true;
      // Implement your report generation logic
      this._utilityService.downloadPlantComparisonReport(formData).subscribe({
        next: (res: Blob) => {
          const blob = new Blob([res], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = url;
          a.download = `Plant_Comparison_Report.xlsx`;
          a.click();
          window.URL.revokeObjectURL(url);
          this.isDownloading = false; // stop loader
        },
        error: () => {
          // this.resetForm();
          this.isDownloading = false; // stop loader on error
          this.toaster.error('Failed to download report. Please try again.');
        }
      });

    } else {
      this.markFormGroupTouched(this.reportForm);
    }
  }

  markFormGroupTouched(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      control?.markAsTouched();

      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  // Helper methods for template
  isFieldInvalid(fieldName: string): boolean {
    const field = this.reportForm.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched));
  }

  getErrorMessage(fieldName: string): string {
    const field = this.reportForm.get(fieldName);
    if (field?.hasError('required')) {
      return 'This field is required';
    }
    if (field?.hasError('pattern')) {
      return 'Please enter a valid number (up to 2 decimals)';
    }
    if (field?.hasError('min')) {
      return 'Value must be greater than or equal to 0';
    }
    if (field?.hasError('minlength')) {
      return 'Please enter at least 10 characters';
    }
    return '';
  }

  resetForm(): void {
    this.reportForm.reset();
    this.selectedPlantA = '';
    this.selectedPlantB = '';
    this.comparisonList = null
  }
}
